import React from 'react';
import { useAdminStore } from '../../stores/useAdminStore';
import './BaseInlineActions.css';

interface BaseInlineActionsProps {
  title: string;
  ariaLabel: string;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  pressed?: boolean;
  'data-testid'?: string;
}

export const BaseInlineActions: React.FC<BaseInlineActionsProps> = ({
  title,
  ariaLabel,
  onClick,
  children,
  className = '',
  disabled = false,
  pressed,
  'data-testid': dataTestId
}) => {
  if (!useAdminStore(s => s.isAdminMode)) {
    return null;
  }

  return (
    <div className={`base-inline-actions ${className}`.trim()}>
      <button
        className="inline-action-icon"
        onClick={onClick}
        title={title}
        aria-label={ariaLabel}
        aria-pressed={pressed}
        aria-busy={disabled || undefined}
        disabled={disabled}
        data-testid={dataTestId}
      >
        {children}
      </button>
    </div>
  );
};
